//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowBigLeft(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.13994 13H19.9999V11H7.13994L12.1799 5H9.55994L3.68994 12L9.55994 19H12.1799L7.13994 13Z" fill="currentColor" /><path d="M7.13994 13H19.9999V11H7.13994L12.1799 5H9.55994L3.68994 12L9.55994 19H12.1799L7.13994 13Z" fill="currentColor" /></svg>;
}
export default IconArrowBigLeft;